export type TeamsLinkAttempt = {
  url: string;
  method: string;
  at: string;
  error?: string;
};

export type TeamsRawLinkClick = {
  phase: string;
  tag: string;
  rawHref: string;
  className: string;
  at: string;
};

const STORAGE_KEY = 'cw-ai-teams-last-link-attempt';
const RAW_CLICK_KEY = 'cw-ai-teams-last-raw-click';

export function recordTeamsLinkAttempt(
  url: string,
  method: string,
  error?: string,
): void {
  const attempt: TeamsLinkAttempt = {
    url,
    method,
    at: new Date().toISOString(),
    error,
  };
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attempt));
  } catch {
    // ignore quota errors
  }
}

export function recordRawLinkClick(click: Omit<TeamsRawLinkClick, 'at'>): void {
  const payload: TeamsRawLinkClick = {
    ...click,
    at: new Date().toISOString(),
  };
  try {
    sessionStorage.setItem(RAW_CLICK_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota errors
  }
}

export function readTeamsLinkAttempt(): TeamsLinkAttempt | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as TeamsLinkAttempt;
  } catch {
    return null;
  }
}

export function readRawLinkClick(): TeamsRawLinkClick | null {
  try {
    const raw = sessionStorage.getItem(RAW_CLICK_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as TeamsRawLinkClick;
  } catch {
    return null;
  }
}
